
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import { Link } from 'react-router-dom';
import ListProducts from './ListProducts';

function Index({dishMenu, setShowDetailProduct}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
      const { dish, alldish } = dishMenu;
  
      const [dataDish, setDataDish] = useState(dish);
      const [dataDesserts, setDataDesserts] = useState(false);
      const [dataDrinks, setDataDrinks] = useState(false);
  
      const [image, setImage] = useState(false);
    
        const [showListProduct, setShowListProduct] = useState(false);
        const [dishs, setdishs] = useState(false);
  
      const {change} = useRefresh();
      const [menus, setMenus] = useState([]);
  
      useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
          });
      }, [change]);
      
      
      useEffect(() => {
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
              }
          });
  
      }, [dataDish]);
  
  
       useEffect(() => {
          menus.map((item) => {
          if (item.name === 'Desserts') {
              setDataDesserts(item);
          }
  
          if (item.name === 'Soft Drinks') {
              setDataDrinks(item);
          }
          });
      }, [menus]);
  
      
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
      const navDish = (position) => {
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      };

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999}}>
           <LayoutContent showBack={false} showLogo={false}>
                <div style={{padding: '10px 20px',}}>
                    <img src={image} style={{  width: '100%',
                                height: 408, borderRadius: 10 }} />
                    <br />

                    <div style={{
                        marginTop: 5,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        display: 'flex'
                    }}>

                        <div style={{
                            fontFamily: "LondrinaSolidRegular",
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '80%'
                        }}>
                        <p className='shor-text-one' style={{fontSize: 32, color: 'white',  textAlign: 'left'}}>
                        {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                        </p>
                    </div>
                        

                        <div style={{
                            display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginRight: 10,
                    }}>
                        <p style={{fontSize: 30, color: 'white',  fontFamily: "LondrinaSolidRegular",}}>
                        $ {dataDish.price.toFixed(2)}
                        </p>
                    </div>
                    </div>
                    
                    <div>
                        <p
                            lineBreakMode="tail"
                            className='shor-text-five'
                        numberOfLines={5}
                        style={{fontSize: 22, textAlign:'left', color: 'white', fontFamily: "LondrinaSolidLight",}}>
                        {langEng ? 
                                        `${dataDish.regular_decription.replace(/\\n/g,'\n')}`
                                    : 
                                    `${translateMenu(
                                        i18n.language, 
                                        dataDish.language, 
                                        dataDish.regular_decription, 
                                        'regular_decription'
                                    )}`
                            }
                            
                        </p>
                    </div>


                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                            marginTop: 5
                        }}>
                            <img
                                style={{
                                width: '40%',
                                height: 20,
                                }}
                                src={require('./assets/brand.png')}
                            />
                            <p
                            style={{
                            alignSelf: 'center',
                            fontSize: 24,
                                textTransform: 'uppercase',
                                color: 'white',
                             
                            fontFamily: "LondrinaSolidRegular",
                            
                        }}>
                        ¡NO OLVIDES!
                        </p>
                        <img
                            style={{
                            width: '40%',
                            height: 20,
                            }}
                            src={require('./assets/brand.png')}
                        />
                    </div>
                   
                    <div
                        style={{
                            marginTop: 10,
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}>
                        <div onClick={()=>[setShowListProduct(true), setdishs(dataDrinks)]} >
                            <img
                            src={require('./assets/App-26.png')}
                            resizeMode={'cover'}
                            style={{
                                width: 330,
                                height: 300,
                                borderRadius: 14,
                                marginBottom: 10,
                                objectFit: 'cover',
                                boderRadius: 20,
                            }}
                            />
                        </div>

                    <Link onClick={()=>[setShowListProduct(true), setdishs(dataDesserts)]}>
                            <img
                                src={require('./assets/App-27.png')}
                                resizeMode={'cover'}
                            style={{
                                width: 330,
                                height: 300,
                                borderRadius: 14,
                                marginBottom: 10,
                                objectFit: 'cover',
                                boderRadius: 20,
                            }}
                            />
                        </Link>
                    </div>

                    <br />

                    <div style={{
                        position: 'absolute',
                        left: 0,
                        bottom: 50,
                        width: '100%',
                        paddingInline: 40,
                        boxSizing: 'border-box',
                        display: 'flex',
                        
                        alignSelf: 'center',
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            width: '30%',
                            textAlign: 'center',
                        }}
                        onClick={()=> navDish(-1)}
                        >
                            <div
                                style={{
                                    borderRadius: 5,
                                    justifyContent: 'center',
                                    backgroundColor: '#f0a63d',
                                    padding: 5,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-around',
                                    background: 'white',
                                    display: 'flex'
                                }}
                            >
                            <div
                                style={{
                                padding: 10,
                                paddingVertical: 5,
                                width: '100%',
                                borderColor: '#b8272e',
                                borderWidth: 2,
                                        alignItems: 'center',
                                borderStyle: 'solid'
                                    }}>
                                    
                                <img src={require('./assets/left.png')} />
                            
                            </div>
                            </div>
                        </div>

                        <div style={{
                            width: '30%',
                                textAlign: 'center',
                        }}>
                            <div
                                style={{
                                borderRadius: 5,
                                justifyContent: 'center',
                                backgroundColor: '#f0a63d',
                                    padding: 5,
                                display: 'flex'
                            }}
                            >
                                <div
                                    onClick={() => setShowDetailProduct(false)}
                                    style={{
                                    padding: 10,
                                    paddingVertical: 3,
                                    width: '100%',
                                    borderColor: '#b8272e',
                                    borderWidth: 2,
                                    borderStyle: 'solid',
                                    textDecoration: 'none'
                                }}>
                                        <p style={{
                                            textAlign: 'center',
                                            color: 'black',
                                            textTransform: 'uppercase',
                                            fontSize: 23,
                                       
                                            fontFamily: "LondrinaSolidRegular",
                                    }}>
                                        {langEng ? " Go Back":  "Ir Atras"}
                                        
                                        </p>
                                </div>
                            </div>
                        </div>

                        <div style={{ width: '30%',
                            textAlign: 'center'
                        }}
                            onClick={()=> navDish(1)}
                        >
                            <div
                                style={{
                                borderRadius: 5,
                                    justifyContent: 'center',
                                    backgroundColor: '#f0a63d',
                                    padding: 5,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-around',
                                    background: 'white',
                                    display: 'flex'
                            }}
                        >
                            <div
                                style={{
                                padding: 10,
                                paddingVertical: 5,
                                width: '100%',
                                borderColor: '#b8272e',
                                borderWidth: 2,
                                        alignItems: 'center',
                                borderStyle: 'solid'
                                }}>
                                <img src={require('./assets/right.png')} />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    
            </LayoutContent>
             {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
        </div>
    );
}
export default Index;